import { EG } from "../uitoolkit/index.js";
import { redirectToLogin } from "./redirect-to-login.js";
export const egenciaFetch = async (url, options) => {
  const { timeout, ...fetchOptions } = options;
  if (timeout) {
    const abortController = new AbortController();
    setTimeout(() => abortController.abort(), timeout);
    fetchOptions.signal = abortController.signal;
  }
  const enrichCommonHeaders = (headers) => {
    headers ??= {};
    headers["Transaction-Id"] = EG?.transactionId;
    headers["Message-Source"] = EG?.commonClientHeaders?.["message-source"];
    headers["Transaction-Source"] = EG?.commonClientHeaders?.["transaction-source"];
    return headers;
  };
  fetchOptions.headers = enrichCommonHeaders(fetchOptions.headers);
  const response = await fetch(url, fetchOptions);
  if (!response.ok) {
    if (response.status === 401) {
      redirectToLogin(window.location.href);
      return response;
    }
    return Promise.reject(response);
  }
  return response;
};
